/** Print in a separate document so modal clipping and popup blockers do not interfere. */
export const printDocument = (html) => new Promise((resolve, reject) => {
  const frame = document.createElement('iframe');
  frame.title = 'Document print preview';
  frame.setAttribute('aria-hidden', 'true');
  frame.setAttribute('sandbox', 'allow-same-origin allow-modals');
  frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:210mm;height:297mm;border:0;';
  let timeout;
  const cleanup = () => {
    clearTimeout(timeout);
    frame.remove();
  };
  timeout = setTimeout(() => {
    cleanup();
    reject(new Error('The print document took too long to load. Please try again.'));
  }, 30000);

  frame.onload = async () => {
    try {
      const printWindow = frame.contentWindow;
      const doc = printWindow.document;
      await Promise.all([
        doc.fonts.ready,
        ...Array.from(doc.images, (img) => img.complete ? Promise.resolve() : new Promise((done) => {
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        })),
      ]);
      if (!frame.isConnected) return;
      clearTimeout(timeout);
      printWindow.addEventListener('afterprint', cleanup, { once: true });
      printWindow.focus();
      printWindow.print();
      resolve();
    } catch (error) {
      cleanup();
      reject(error);
    }
  };
  frame.srcdoc = html;
  document.body.appendChild(frame);
});

export const printElement = (element) => {
  if (!element) return Promise.reject(new Error('Document content is unavailable.'));
  const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'), (node) => node.outerHTML).join('\n');
  const base = document.createElement('base');
  base.href = document.baseURI;
  return printDocument(`<!doctype html><html><head><meta charset="utf-8">${base.outerHTML}${styles}</head><body>${element.outerHTML}</body></html>`);
};
